import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import { localStorage, setTimeLocalStorage } from '@/store/storage';
import moment from 'moment';
import Signin from '@/api/modules/signin';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import floatOPS from '@/utils/floatOPS';
import Content from './content.vue';
export default {
  name: 'shoppingCart',
  props: {
    drawerShow: {
      modelValue: Boolean
    }
  },
  components: {
    Content: Content
  },
  data: function data() {
    return {};
  },
  watch: {
    drawerShow: {
      handler: function handler(to, from) {
        this.registerPop = this.drawerShow;
      },
      deep: true,
      immediate: true
    }
  },
  computed: _objectSpread(_objectSpread({
    registerNumber: function registerNumber(list) {
      return function (list) {
        var num = 0;
        list.forEach(function (item, i) {
          if (item.domainStatus == 0) {
            num = num + 1;
          }
        });
        return num;
      };
    }
  }, mapState(['chainid', 'account', 'accessToken', 'signConnectCallBack'])), {}, {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    }
  }),
  mounted: function mounted() {},
  methods: {
    cleanVal: function cleanVal() {
      if (!this.invitationCode) {
        this.inviteeDiscount = 1;
        this.setPrice();
      }
    },
    getCouponPrice: function getCouponPrice() {
      var _this = this;
      var num = 0;
      this.priceList.forEach(function (item, i) {
        if (_this.couponList.indexOf(item.id) != -1) {
          num = _this.calculate(num, Number(item.value), 2, 'a');
        }
      });
      return num;
    },
    handleBtn: function handleBtn(e) {
      this.nowActive = e;
      if (e == 1) {
        this.getInvitationCode();
      } else {
        this.getCoupons();
      }
    },
    handleRegisterBox: function handleRegisterBox() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var activeName, arr, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this2.$store.state.accessToken) {
                _context.next = 4;
                break;
              }
              _this2.$store.commit('setSignConnect', false);
              _this2.$store.commit('setSignConnect', true);
              return _context.abrupt("return");
            case 4:
              activeName = _this2.couponList.length > 0 ? _this2.couponList : '';
              arr = [];
              _this2.shopCartList.forEach(function (item, i) {
                var periodType, num;
                if (item.way_status == 1) {
                  periodType = 1;
                  num = item.num;
                } else {
                  periodType = 5;
                  num = 1;
                }
                if (item.is_free) {
                  periodType = 0;
                  num = 1;
                }
                var json = {
                  name: item.name,
                  periodType: periodType,
                  num: num
                };
                if (item.domainStatus == 0) {
                  arr.push(json);
                }
              });
              if (_this2.inviteStatus != 2) {
                _this2.invitationCode = '';
              }
              _context.next = 10;
              return _this2.handleRegister(arr, activeName, true);
            case 10:
              res = _context.sent;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var arr, domainArr, object, priceArr, format;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.couponList = [];
              _this3.shopCartList = [];
              _this3.loading = true;
              arr = localStorage.getObject('shoppingCartList');
              domainArr = [];
              if (_this3.$store.state.account) {
                _context2.next = 8;
                break;
              }
              _this3.loading = false;
              return _context2.abrupt("return");
            case 8:
              if (arr) {
                _context2.next = 11;
                break;
              }
              _this3.loading = false;
              return _context2.abrupt("return");
            case 11:
              _this3.shopList = arr;
              arr.forEach(function (item) {
                domainArr.push(item.name);
              });
              if (!(arr.length > 0)) {
                _context2.next = 30;
                break;
              }
              object = {
                names: domainArr,
                inviteCode: _this3.invitationCode
              };
              _context2.prev = 15;
              _this3.getInvitationCode();
              _context2.next = 19;
              return Signin.getPriceInfo(object);
            case 19:
              priceArr = _context2.sent;
              format = _this3.$localFormat();
              arr.forEach(function (item) {
                var domainItem = {
                  name: item.name,
                  expired: priceArr.domains[item.name].expiredAt ? moment(priceArr.domains[item.name].expiredAt * 1000).format(format) : 0,
                  // resolver: item[1],
                  checke: false,
                  num: 1,
                  is_free: priceArr.domains[item.name].freeFlag,
                  price: Number(priceArr.domains[item.name].priceYear),
                  buyOut: Number(priceArr.domains[item.name].buyoutPrice),
                  way_status: 1,
                  domainStatus: priceArr.domains[item.name].domainStatus
                };
                _this3.shopCartList.push(domainItem);
              });
              _this3.shopCartList.forEach(function (item, i) {
                if (item.domainStatus == 3) {
                  // this.handRemove(i, item);
                }
              });
              _this3.getGasPrice(_this3.registerNumber(_this3.shopCartList), 1);
              _this3.gasTime = setInterval(function () {
                _this3.getGasPrice(_this3.registerNumber(_this3.shopCartList), 1);
              }, 60000);
              _this3.setPrice();
              _context2.next = 30;
              break;
            case 28:
              _context2.prev = 28;
              _context2.t0 = _context2["catch"](15);
            case 30:
              _this3.loading = false;
              _this3.getCoupons();
              _this3.setPrice();
            case 33:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[15, 28]]);
      }))();
    },
    handleRefresh: function handleRefresh() {
      var arr = [];
      this.shopCartList.forEach(function (item, i) {
        item.num = 1;
        item.way_status = 1;
        arr.push(item);
      });
      this.shopCartList = [].concat(arr);
      this.nowActive = 1;
      this.couponList = [];
      this.setPrice();
    },
    handleClosesBox: function handleClosesBox() {
      if (this.gasTime) {
        clearInterval(this.gasTime);
        this.gasTime = null;
      }
      this.$emit('handHideCard');
    },
    handleChange: function handleChange(e) {},
    handleChangeYear: function handleChangeYear(value) {
      this.setPrice();
    },
    handRemove: function handRemove(e, list) {
      this.shopCartList = this.shopCartList.filter(function (item, i) {
        return e !== i;
      });
      var json = [];
      this.shopList = this.shopList.filter(function (item, i) {
        return item.name != list.name;
      });
      var shoppingList = JSON.parse(localStorage.getItem('shoppingCartList')) || json;
      if (shoppingList) {
        shoppingList = shoppingList.filter(function (col) {
          return col.name != list.name;
        });
      } else {
        shoppingList = [];
      }
      localStorage.setObject('shoppingCartList', shoppingList);
      this.$store.commit('setShoppingCartNumber', JSON.stringify(shoppingList));
      this.setPrice();
    },
    handRemoveAll: function handRemoveAll() {
      this.shopCartList = [];
      localStorage.removeItem('shoppingCartList');
      this.$store.commit('setShoppingCartNumber', JSON.stringify(this.shopCartList));
      this.setPrice();
    },
    setPrice: function setPrice() {
      var _this4 = this;
      this.usdPrice = '';
      this.originalPrice = 0;
      this.shopCartList.forEach(function (item, index) {
        if (item.domainStatus == '0' && !item.is_free) {
          if (item.way_status == 1) {
            _this4.originalPrice = floatOPS.a(_this4.originalPrice, floatOPS.m(item.price, item.num, 2));
          } else {
            _this4.originalPrice = floatOPS.a(Number(_this4.originalPrice), floatOPS.a(_this4.originalPrice, Number(item.buyOut), 2));
          }
        }
      });
      this.price = this.originalPrice;
      if (this.nowActive == 1) {
        if (this.inviteStatus == 2) {
          this.price = floatOPS.m(this.originalPrice, this.inviteeDiscount, 2);
        } else {
          this.price = this.originalPrice;
        }
      } else {
        if (this.couponList.length > 0) {
          this.priceList.forEach(function (item, i) {
            var isIcloun = _this4.couponList.filter(function (element) {
              return element === item.id;
            });
            if (isIcloun.length > 0) {
              _this4.price = floatOPS.s(_this4.price, item.value, 2);
            }
          });
        }
      }
      if (this.price < 0) {
        this.price = 0;
      }
      this.getUseNum(Number(this.price));
    },
    handChange: function handChange() {
      this.invitationCode = '';
      this.setPrice();
    },
    handSelect: function handSelect(index, e) {
      this.shopCartList[index].way_status = e;
      this.setPrice();
    }
  }
};